import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["name", "options", "value"];
import { SideNav, SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FilterSideNav(_ref) {
  let {
      name,
      options,
      value
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(SideNav, Object.assign({}, rest, {
    value: value !== null && value !== void 0 ? value : '',
    children: options.map(({
      href,
      text,
      value: optionValue
    }) => /*#__PURE__*/_jsx(SideNavItem, {
      role: "link",
      "data-test-id": `filter-nav-item::${name}::${optionValue}`,
      href: href,
      title: text,
      value: optionValue
    }, `${name}-${optionValue}`))
  }));
}